import React, { useState, useEffect } from "react";

import { useUserAuth } from "../../context/UserAuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import "./SuperAdmin.css";
import DashboardLayout from "../Layout/DashboardLayout";
// Import real components for each section
import AddAdmin from "../../pages/AddAdmin/AddAdmin";
import ViewAllAdmin from "../../pages/ViewAllAdmin/ViewAllAdmin";
import AdminBillingUsage from "../../pages/AdminBillingUsage/AdminBillingUsage";
import AuditLogs from "../../AdminPages/AuditLogs/AuditLogs";

function SuperAdmin() {
  const { logOut } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Initialize activeSection based on URL parameter to prevent flicker
  const getInitialSection = () => {
    const params = new URLSearchParams(location.search);
    const section = params.get('section');
    return (section && ['addAdmin', 'viewAdmins', 'billing', 'auditLogs'].includes(section)) ? section : "addAdmin";
  };
  
  const [activeSection, setActiveSection] = useState(getInitialSection);

  // Check URL parameters to set active section
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get('section');
    if (section && ['addAdmin', 'viewAdmins', 'billing', 'auditLogs'].includes(section)) {
      setActiveSection(section);
    }
  }, [location.search]);

  // Update URL when section changes
  const handleSectionChange = (section) => {
    setActiveSection(section);
    navigate(`/SuperAdmin?section=${section}`, { replace: true });
  };


  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  // Render the real content for each section
  const renderContent = () => {
    switch (activeSection) {
      case "addAdmin":
        return <AddAdmin />;
      case "viewAdmins":
        return <ViewAllAdmin />;
      case "billing":
        return <AdminBillingUsage />;
      case "auditLogs":
        return <AuditLogs isSuperAdmin />;
      default:
        return <div className="dashboard-content">Select an option from the sidebar.</div>;
    }
  };

  const menuItems = [
    { key: "addAdmin", label: "Add Admin" },
    { key: "viewAdmins", label: "View Admins" },
    { key: "billing", label: "Billing" },
    { key: "auditLogs", label: "Audit Logs" },
  ];

  return (
    <DashboardLayout
      menuItems={menuItems}
      activeKey={activeSection}
      onSelect={handleSectionChange}
      onLogout={handleLogout}
    >
      {renderContent()}
    </DashboardLayout>
  );
}

export default SuperAdmin;
